/**
 *  The content returned by getFileAttachment call is prefixed with header like data:image/jpeg;base64.
 *  This util removes that info.
 */
const removeDataHeaderInfoFromContent = (content: string): string => {
    if (!content) {
        return content;
    }
    // Try to remove the header
    if (content.indexOf('data:') === 0) {
        const endOfHeader = ';base64,';
        const index = content.indexOf(endOfHeader);
        return content.substr(index + endOfHeader.length);
    } else {
        return content;
    }
};

export default removeDataHeaderInfoFromContent;
